exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nav-link {\n  padding: 0;\n  color: #0C0C0C; }\n  .nav-link:hover {\n    color: #0C0C0C; }\n\n.dropdown-item:hover, .dropdown-item:active {\n  background: #F8DEC0 !important; }\n", ""]);

